<form *ngIf="initialized" [formGroup]="form" class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper [label]="'Name'" [name]="'title'" [colSize]="7">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>
    <app-icon-dropdown
      [formField]="form.get('icon')"
      [colSize]="2"
      [mode]="'fa'"
      formControlName="icon"
      label="Icon"
      name="icon"></app-icon-dropdown>
  </div>

  <div class="grid">
    <app-form-field-wrapper [label]="'Beschreibung'" [name]="'description'">
      <textarea
        pInputTextarea
        id="description"
        formControlName="description"
        class="p-inputtextarea"></textarea>
    </app-form-field-wrapper>
  </div>

  <div class="grid">
    <app-form-field-wrapper
      [label]="'sichtbar'"
      [name]="'visible'"
      [colSize]="4"
      [floatingLabel]="true">
      <p-inputSwitch formControlName="visible"></p-inputSwitch>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'im Spotlight'"
      [name]="'spotlight'"
      [colSize]="4"
      [floatingLabel]="true">
      <p-inputSwitch formControlName="spotlight"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>

  <p-divider />

  <div class="grid">
    <div class="col-12 md:col-6">
      <div class="p-card p-3 h-full">
        <app-header
          icon="fas fa-layer-group"
          text="Bereiche ohne Thema (Fallback)"
          sub="Diese Bereiche sind aktuell keinem Thema zugeordnet und erscheinen automatisch im Fallback-Thema."></app-header>

        <div class="flex flex-column gap-2">
          @if (unassignedCategories.length) {
            @for (category of unassignedCategories; track category._id) {
              <div
                [class.border-bottom-1]="!$last"
                [class.surface-border]="!$last"
                class="flex align-items-center gap-2 pt-2 pb-3">
                <i class="fas fa-layer-group"></i>
                <span>{{ category.title }}</span>
              </div>
            }
          } @else {
            <span class="text-color-secondary font-italic"
              >Aktuell sind alle Bereiche einem Thema zugeordnet.</span
            >
          }
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="p-card p-3 h-full">
        <app-header
          icon="fas fa-book-open"
          text="Bereiche mit Thema"
          sub="Von hier aus können Sie einen Bereich von seinem Thema lösen, damit er ins Fallback-Thema wandert."></app-header>

        <div class="flex flex-column gap-2">
          @for (category of availableCategories; track category._id) {
            <div
              [class.border-bottom-1]="!$last"
              [class.surface-border]="!$last"
              class="flex align-items-center justify-content-between gap-2 py-2">
              <div class="flex flex-column gap-1">
                <span class="flex align-items-baseline gap-2">
                  <i class="fas fa-layer-group"></i>
                  <div class="flex flex-column gap-1">
                    <span>{{ category.title }}</span>
                    @if (getTopicTitles(category._id); as topicTitles) {
                      <span class="text-color-secondary text-sm">{{
                        topicTitles
                      }}</span>
                    }
                  </div>
                </span>
              </div>
              <p-button
                icon="fas fa-link-slash"
                label="aus Thema lösen"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                (onClick)="unlinkFromTopics(category)"></p-button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</form>
